import React, { Component } from "react"
import Button from "react-bootstrap/Button"
import A from "../images/smssagan.png"

const divStyles = {
  padding: `1rem 3rem`,
  background: `#f5f5f5`,
}

const imgStyles = {
  margin: `1rem 0 2rem 0`,
  width: `100%`,
}

const headlineStyles = {
  textAlign: `center`,
  fontSize: `2.2rem`,
  fontWeight: `600`,
  paddingTop: `1rem`,
}

const paraStyles = {
  textAlign: `center`,
  fontSize: `1.15rem`,
  fontWeight: `500`,
}

export default class CompParaFirst extends Component {
  render() {
    return (
      <div style={divStyles} className="portdivs">
        <div style={{ paddingTop: `1rem` }}>
          <h1 style={headlineStyles}>SMS Meets</h1>
          <p style={paraStyles} className="portdivstext">
            SMS Meets fills an often-cited need for small businesses to be able
            to confirm appointment times with clients and stakeholders. Warning:
            Tech content follows: A fast application built using Amazon Web
            Services SMS servers, NodeJS and Express backend to fulfill
            delivery.
          </p>
        </div>
        <img
          src={A}
          alt="portfoliosmsmeets"
          style={imgStyles}
          className="portimgs"
        />
        <span
          style={{
            display: `grid`,
            justifyContent: `center`,
            marginBottom: `2.0rem`,
          }}
        >
          <a
            rel="noreferrer noopener"
            target="_blank"
            href="https://protected-thicket-83515.herokuapp.com/"
          >
            <Button
              style={{
                marginBottom: `0.0rem`,
                backgroundColor: `#FF5722`,
                border: `none`,
                fontWeight: `600`,
                height: `3rem`,
                width: `12rem`,
                margin: `auto`,
                display: `grid`,
                placeContent: `center`
              }}
            >
              TRY IT
            </Button>
          </a>
        </span>
      </div>
    )
  }
}
